import React, { useEffect, useState } from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link as ReachLink } from "@reach/router";

import Api from "./Api";

import Logo from "../assets/images/logo_zoomed_90x90.png";
import { useAppContext } from "libs/contextLib";
import { COMMON_ERROR, SUPPORT_EMAIL_ID } from "constants/common";
import { STUDENT_URLS } from "constants/urls";

import "./navbar.scss";

function MyNavbar() {
  const CONTACT_MAIL = `mailto:${SUPPORT_EMAIL_ID}`;
  const {
    authenticatedUser,
    authenticateUser,
    updateErrorMessage,
  } = useAppContext();
  const [navExpanded, setNavExpanded] = useState(false);

  const closeNav = () => setNavExpanded(false);

  function handleLogout() {
    Api()
      .post(STUDENT_URLS.LOGOUT)
      .then(
        (response) => {
          if (response.status === 200) {
            authenticateUser(null);
            closeNav();
          }
        },
        (error) => {
          console.log(error);
          updateErrorMessage(COMMON_ERROR);
        }
      );
  }

  useEffect(() => {
    Api()
      .get(STUDENT_URLS.PROFILE)
      .then(
        (response) => {
          if (response.status === 200) authenticateUser(response.data);
        },
        (error) => {
          console.log(error);
          // TODO: analyse if setting user null can be avoided for some cases
          authenticateUser(null);
        }
      );
  }, [authenticateUser]);

  return (
    <Navbar
      expand="lg"
      sticky="top"
      expanded={navExpanded}
      onToggle={setNavExpanded}
      id="container-navbar"
    >
      <Navbar.Brand as={ReachLink} to="/" id="navbar-brand">
        <img src={Logo} alt="company logo" style={{ height: 40 }} />
        {"  "}
        <p id="text-navbar-edify" className="text">
          Edify
        </p>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav"></Navbar.Toggle>
      <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
        <Nav>
          <Nav.Link
            as={ReachLink}
            to="teach"
            className="mr-4 text-center nav-links text"
            onClick={closeNav}
          >
            For Creators
          </Nav.Link>
          <Nav.Link
            as={ReachLink}
            to="learn"
            className="mr-4 text-center nav-links text"
            onClick={closeNav}
          >
            For Learners
          </Nav.Link>
          {/* <Nav.Link
            href={CONTACT_MAIL}
            className="mr-4 text-center nav-links text"
            onClick={closeNav}
          >
            Support
          </Nav.Link>
          <Nav.Link
            as={ReachLink}
            to="/"
            className="mr-4 text-center nav-links text"
            onClick={closeNav}
          >
            About
          </Nav.Link> */}
          {authenticatedUser ? (
            <NavDropdown
              id="nav-dropdown"
              className="text-center nav-links text"
              title={authenticatedUser.first_name}
            >
              <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
            </NavDropdown>
          ) : (
            <Nav.Link
              as={ReachLink}
              to="login"
              className="text-center nav-links text"
              onClick={closeNav}
            >
              Login
            </Nav.Link>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default MyNavbar;
